<template>
    <div class="lead-form-overlay u-typography-root">
        <button class="lead-form-overlay__close" @click.prevent="close">
            <ui-icon size="medium" symbol="close"/>
        </button>
        <h4 class="u-reset lead-form-overlay__title">
            Factsheet herunterladen
        </h4>
        <h6 class="u-reset lead-form-overlay__subtitle">
            {{ title }}
        </h6>
        <form class="lead-form-overlay__form" v-if="!showDownload" @submit.prevent="submitForm">
            <ui-model-provider v-model="formData.salutation" v-slot="{ value, updateValue }">
                <div class="ui-form-field ui-form-field__base ui-form-field__list ui-form-field__is-required">
                    <div class="ui-form-field--title-label">
                        Anrede*
                    </div>
                    <div class="ui-form-field--row">
                        <div class="ui-form-field--input-container">
                            <ui-radio
                                    class="ui-form-field--list-item"
                                    :checked="value === 'Herr'"
                                    :value="'Herr'"
                                    :required="true"
                                    :name="'salutation'"
                                    ref="initialRadio"
                                    @change="updateValue">
                                <template v-slot:label>
                                    Herr
                                </template>
                            </ui-radio>
                        </div>
                        <div class="ui-form-field--input-container">
                            <ui-radio
                                    class="ui-form-field--list-item"
                                    :checked="value === 'Frau'"
                                    :value="'Frau'"
                                    :required="true"
                                    :name="'salutation'"
                                    @change="updateValue">
                                <template v-slot:label>
                                    Frau
                                </template>
                            </ui-radio>
                        </div>
                    </div>
                </div>
            </ui-model-provider>
            <div class="lead-form-overlay__form-fields">
                <ui-model-provider v-model="formData.first_name" v-slot="{ value, updateValue }">
                    <ui-input class="form-field"
                            :value="value"
                            :required="true"
                            @input="updateValue">
                        <template v-slot:label>
                            Vorname*
                        </template>
                    </ui-input>
                </ui-model-provider>

                <ui-model-provider v-model="formData.last_name" v-slot="{ value, updateValue }">
                    <ui-input class="form-field"
                            :value="value"
                            :required="true"
                            @input="updateValue">
                        <template v-slot:label>
                            Nachname*
                        </template>
                    </ui-input>
                </ui-model-provider>

                <ui-model-provider v-model="formData.phone" v-slot="{ value, updateValue }">
                    <ui-input
                            class="form-field"
                            :value="value"
                            type="tel"
                            @input="updateValue">
                        <template v-slot:label>
                            Telefonnummer
                        </template>
                    </ui-input>
                </ui-model-provider>

                <ui-model-provider v-model="formData.email" v-slot="{ value, updateValue }">
                    <ui-input
                            class="form-field"
                            :value="value"
                            type="email"
                            :required="true"
                            @input="updateValue">
                        <template v-slot:label>
                            E-Mail Adresse*
                        </template>
                    </ui-input>
                </ui-model-provider>
            </div>
            <div>
                <ui-model-provider v-model="formData.referral_sources" v-slot="{ value, updateValue }">
                    <div class="ui-form-field ui-form-field__base ui-form-field__list ui-form-field__is-required">
                        <div class="ui-form-field--title-label">
                            Wie sind Sie auf uns aufmerksam geworden?*
                        </div>
                        <div class="ui-form-field--row">
                            <div class="ui-form-field--input-container lead-form-overlay__checkbox"
                                    v-for="source in referralSources"
                                    :key="source.value">
                                <ui-checkbox
                                        class="ui-form-field--list-item"
                                        :checked="value.includes(source.value)"
                                        :value="source.value"
                                        :name="'referral_source'"
                                        @change="updateValue">
                                    <template v-slot:label>
                                        {{ source.label }}
                                    </template>
                                </ui-checkbox>
                            </div>
                        </div>
                    </div>
                </ui-model-provider>
            </div>
            <div>
                <ui-model-provider v-model="formData.referral_source_other" v-slot="{ value, updateValue }">
                    <ui-input
                            :value="value"
                            class="form-field"
                            placeholder="Bitte geben Sie weitere Informationen an"
                            v-if="formData.referral_sources.includes('other')"
                            @input="updateValue">
                        <template v-slot:label>
                            Weitere Angaben
                        </template>
                    </ui-input>
                </ui-model-provider>
            </div>
            <div class="lead-form-overlay__submit-wrapper">
                <ui-model-provider v-model="formData.consent" v-slot="{ value, updateValue }">
                    <div class="ui-form-field ui-form-field__base">
                        <div class="ui-form-field--input-container">
                            <ui-checkbox class="ui-form-field--list-item lead-form-overlay__checkbox--center-align"
                                    :checked="value"
                                    :value="true"
                                    :required="true"
                                    @change="updateValue">
                                <template v-slot:label>
                                    <span class="label--line-break">
                                        Ich bin einverstanden, dass meine Daten an Juventus übermittelt werden.*
                                    </span>
                                </template>
                            </ui-checkbox>
                        </div>
                    </div>
                </ui-model-provider>
                <simple-btn class="lead-form-overlay__submit-btn" type="submit" :facets="['primary', 'medium', 'has-grid']">
                    Zum Download
                </simple-btn>
            </div>
            <div class="lead-form-overlay__error" v-if="error">
                Etwas ist schief gelaufen. Bitte versuchen Sie es später erneut.
            </div>
        </form>
        <div v-if="showDownload">
            <div class="lead-form-overlay__download">
                <a class="lead-form-overlay__download-btn btn btn__primary btn__medium btn__has-grid"
                        :href="factsheet.url"
                        download
                        target="_blank"
                        v-for="(factsheet, index) in factsheets"
                        :key="index"
                        @click="trackDownload(factsheet.title)">
                    {{ factsheet.title }}
                    <div class="btn--icon">
                        <ui-icon size="medium" symbol="download"/>
                    </div>
                </a>
            </div>
            <div class="lead-form-overlay__advisor-container">
                <h6 class="u-reset">
                    Beratung
                </h6>
                <div class="lead-form-overlay__advisor">
                    <picture-element
                            class="lead-form-overlay__advisor-image"
                            :lazy="false"
                            :urls="advisor.image.urls"/>
                    <div class="lead-form-overlay__advisor-contact">
                        <div class="text-link text-link__sidebar u-reset lead-form-overlay__text-link--black">
                            <div class="text-link--text">
                                {{ advisor.first_name }} {{ advisor.last_name }}
                            </div>
                        </div>
                        <a class="text-link text-link__sidebar u-reset"
                                :href="advisor.outlook"
                                target="_blank"
                                v-if="advisor.outlook">
                            <div class="text-link--text">
                                Termin buchen
                            </div>

                            <div class="text-link--arrow-wrap">
                                <span class="text-link--arrow"/>
                            </div>
                        </a>
                        <a class="text-link text-link__sidebar u-reset"
                                :href="`mailto:${advisor.email}`">
                            <div class="text-link--text">
                                E-Mail
                            </div>

                            <div class="text-link--arrow-wrap">
                                <span class="text-link--arrow"/>
                            </div>
                        </a>
                        <a class="text-link text-link__sidebar u-reset lead-form-overlay__text-link--black"
                                :href="`tel:${advisor.phone}`">
                            <div class="text-link--text">
                                {{ advisor.phone }}
                            </div>

                            <div class="text-link--arrow-wrap">
                                <span class="text-link--arrow"/>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import { mapActions } from 'vuex';
    import UiModelProvider from '@dreipol/vue-ui/src/components/form/model-provider/model-provider.vue';
    import UiRadio from '@dreipol/vue-ui/src/components/form/radio/radio.vue';
    import UiInput from '@dreipol/vue-ui/src/components/form/input/input.vue';
    import UiCheckbox from '@dreipol/vue-ui/src/components/form/checkbox/checkbox.vue';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import SimpleBtn from '../../components/buttons/simple-btn/simple-btn.vue';
    import PictureElement from '../picture-element/picture-element';

    const REFERRAL_SOURCES = [
        { value: 'acquaintance', label: 'von Bekannten empfohlen' },
        { value: 'google', label: 'Google Suche' },
        { value: 'socialmedia', label: 'Instagram (Facebook)' },
        { value: 'linkedin', label: 'LinkedIn' },
        { value: 'newsletter', label: 'Newsletter' },
        { value: 'radio', label: 'Radiowerbung' },
        { value: 'billboard', label: 'Plakatwerbung' },
        { value: 'other', label: 'sonstiges' },
    ];

    export default {
        components: {
            UiModelProvider,
            UiRadio,
            UiInput,
            UiCheckbox,
            UiIcon,
            SimpleBtn,
            PictureElement,
        },
        mixins: [
            bemMixin('gallery-overlay'),
        ],
        props: {
            title: {
                type: String,
                required: true,
            },
            csrf: {
                type: String,
                required: true,
            },
            service: {
                type: String,
                required: true,
            },
            contact: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                formData: {
                    salutation: '',
                    first_name: '',
                    last_name: '',
                    phone: '',
                    email: '',
                    referral_sources: [],
                    referral_source_other: '',
                    consent: false,
                },
                error: false,
                showDownload: false,
                advisor: null,
                factsheets: [],
                referralSources: REFERRAL_SOURCES,
            };
        },
        methods: {
            ...mapActions('vue-ui/overlay', ['openOverlay', 'closeOverlay']),
            close() {
                this.closeOverlay({ id: 'LEAD_FORM_OVERLAY', transition: 'trs-simple-fade' });
            },
            submitForm() {
                const formData = new FormData();
                formData.append('salutation', this.formData.salutation === 'Herr' ? 'm' : 'f');
                formData.append('first_name', this.formData.first_name);
                formData.append('last_name', this.formData.last_name);
                formData.append('phone', this.formData.phone);
                formData.append('email', this.formData.email);
                formData.append('referral_sources', this.formData.referral_sources.join(','));
                formData.append('referral_source_other', this.formData.referral_source_other);
                formData.append('consent', this.formData.consent);
                formData.append('service', this.service);
                formData.append('teaser_contact', this.contact);

                fetch('/lead-form/', {
                    method: 'POST',
                    headers: {
                        'X-CSRFToken': this.csrf,
                    },
                    body: formData,
                })
                    .then(response => {
                        if (response.ok) {
                            this.showDownload = true;
                            response.json().then(data => {
                                this.advisor = data.advisor;
                                this.factsheets = data.factsheets;
                            });

                            this.trackRegistration();
                        } else {
                            this.error = true;
                        }
                    })
                    .catch(err => console.error('Network error:', err));
            },
            trackRegistration() {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        kurs: this.title,
                        event: 'registration_factsheet',
                    });
                }
            },
            trackDownload(title) {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'download_factsheet',
                        title,
                    });
                }
            },
        },
        mounted() {
            this.$nextTick(() => {
                document.getElementsByClassName('ui-form-field--input')[0].focus();
            });
        },
    };
</script>
